import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

import './scss/_common.scss'

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
